var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "88.281%",
    y1: "100%",
    x2: "11.719%",
    y2: "0%",
    id: "Import_svg__[object_Object]c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B8B99",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BADBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-.4%",
    y: "-3.6%",
    width: "100.9%",
    height: "109.3%",
    filterUnits: "objectBoundingBox",
    id: "Import_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0534309441 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Import_svg__[object_Object]b",
    x: 0,
    y: 0,
    width: 1004,
    height: 97,
    rx: 6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26 -65)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#Import_svg__[object_Object]a)",
    xlinkHref: "#Import_svg__[object_Object]b"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#E1E9F0",
    fill: "#FFF",
    x: -0.5,
    y: -0.5,
    width: 1005,
    height: 98,
    rx: 6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V4a2 2 0 012-2h10zm-6.389 9H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5H5.61a.5.5 0 00.5-.5v-.62a.5.5 0 00-.5-.5zm2.667-2.7H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5h5.222a.5.5 0 00.5-.5V8.8a.5.5 0 00-.5-.5zm2.666-2.7H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5h7.888a.5.5 0 00.5-.5V6.1a.5.5 0 00-.5-.5z",
    transform: "translate(0 -2)",
    fill: "url(#Import_svg__[object_Object]c)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default ForwardRef;